globalThis.backoffice = globalThis.backoffice || {};
backoffice.integrations = backoffice.integrations || {};
backoffice.integrations.voip = backoffice.integrations.voip || {};

backoffice.integrations.voip.Graam = (function() {
  function Graam() {}

  Graam.prototype = {
    startCall: function(calledNumber, callingNumber, callback) {
      if(callingNumber == '') {
        callingNumber = null;
      }
      globalThis.wePhoneCallCenter.make_call(calledNumber, callingNumber, null, 'Commerciaux', '', function(response) {
        if(typeof callback == 'function') callback();
      }, function(errorCode, errorMessage) {
        new PNotify({icon: 'icon-cross2', title: "Impossible de lancer l'appel", type: 'error'});
      });
    }
  }

  return Graam;
})();
